<app-dialog class="remove-appliance-dialog">
  <ng-container dialog-title>
    <p class="remove-appliance-dialog__title">Are you sure?</p>
    <app-icon
      (click)="onCancel()"
      [family]="'solid'"
      [icon]="'square-xmark'"
      [size]="'xl'"
      class="remove-appliance-dialog__icon"
    />
  </ng-container>

  <ng-container dialog-content>
    <p class="remove-appliance-dialog__description">
      Please confirm you want to remove {{ data?.clientName }} Protection?
    </p>
  </ng-container>

  <ng-container dialog-actions>
    <div class="remove-appliance-dialog__actions">
      <app-button (click)="onConfirm()" [fill]="true" [variant]="'primary'">
        Confirm
      </app-button>
      <app-button
        (click)="onCancel()"
        [fill]="true"
        [variant]="'primary-alternative'"
      >
        Cancel
      </app-button>
    </div>
  </ng-container>
</app-dialog>
